const subscriptionBasedWomen = [
	{
		id: '6201',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Top Wear (Shirt, T-shirt, Fatua)',
		description: 'Shirt-2pis, T-shirt-2pis, Fatua-2pis',
		category: "Women's Wear",
		service: 'Subscription Based',
		price: 110,
		quantity: 1
	},
	{
		id: '6202',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Presentation dress (Sari, Blouse, Petticoat)',
		description: 'Sari-2pis, Blouse-2pis, Petticoat-2pis',
		category: "Women's Wear",
		service: 'Subscription Based',
		price: 130,
		quantity: 1
	},
	{
		id: '6203',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Long Dress (Borka, Jumpsuit, Arabian Dress)',
		description: 'Borka-3pis, Jumpsuit-2pis, Arabian Dress-1pis',
		category: "Women's Wear",
		service: 'Subscription Based',
		price: 220,
		quantity: 1
	},
	{
		id: '6204',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Winter wear (Sweater, Cardigan)',
		description: 'Sweater-2pis, Cardigan-3pis',
		category: "Women's Wear",
		service: 'Subscription Based',
		price: 180,
		quantity: 1
	},
	{
		id: '6205',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Saree (Plain Cotton, Plain Silk, Cotton Design)',
		description: 'Plain Cotton-2pis, Plain Silk-2pis, Cotton Design-2pis',
		category: "Women's Wear",
		service: 'Subscription Based',
		price: 400,
		quantity: 1
	},
	{
		id: '6206',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Exclusive Set (Benarasi, Jamdani, Blouse)',
		description: 'Benarasi-2pis, Jamdani-1pis, Petticote-2pis, Blouse-2pis',
		category: "Women's Wear",
		service: 'Subscription Based',
		price: 475,
		quantity: 1
	},
	{
		id: '6207',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Marriage Set ( Benarasi, Petticote, Blouse)',
		description: 'Benarasi-2pis, Petticode-2pis, Blouse-2pis',
		category: "Women's Wear",
		service: 'Subscription Based',
		price: 350,
		quantity: 1
	}
];
export default subscriptionBasedWomen;
